import { ref, onMounted, onUnmounted, computed } from 'vue'

/*
  - sm 40rem (640px)
  - md 48rem (768px)
  - lg 64rem (1024px)
  - xl 75rem (1200px)
  - 2xl 80rem (1280px)
*/

export function useViewportSize() {
  const width = ref(window.innerWidth)
  const height = ref(window.innerHeight)
  const isMobile = computed(() => width.value < 768)
  const isSmOrGreater = computed(() => width.value >= 400)
  const isMdOrGreater = computed(() => width.value >= 768)
  const isLgOrGreater = computed(() => width.value >= 1024)
  const is2XlOrGreater = computed(() => width.value >= 1280)
  const is3XlOrGreater = computed(() => width.value >= 1536)
  const is4XlOrGreater = computed(() => width.value >= 1920)
  const is5XlOrGreater = computed(() => width.value >= 2400)

  const updateSize = () => {
    width.value = window.innerWidth
    height.value = window.innerHeight
  }

  onMounted(() => {
    window.addEventListener('resize', updateSize)
  })

  onUnmounted(() => {
    window.removeEventListener('resize', updateSize)
  })

  return {
    width,
    height,
    isMobile,
    isSmOrGreater,
    isMdOrGreater,
    isLgOrGreater,
    is2XlOrGreater,
    is3XlOrGreater,
    is4XlOrGreater,
    is5XlOrGreater
  }
}
